module.exports = __webpack_public_path__ + "img/1-2.8da36da1.png";